import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	fetchCourseData,
	setCourseID,
	updateCourse,
} from '../redux/course/courseSlice';
import { fetchAllModules, updateModules } from '../redux/modules/moduleSlice';

const CourseDropDown = () => {
	const dispatch = useDispatch();

	const CourseState = useSelector((state: any) => state.course);
	const { courseID, allCourses } = CourseState;

	const UserState = useSelector((state: any) => state.user);
	const { courseList } = UserState;

	const handleCourseChange = async (newCourseID: any) => {
		// const newCourseID: string = event.target.value;
		console.log('ID -> ', newCourseID);
		if (typeof newCourseID === 'string') {
			await localStorage.setItem('selected-course-token', newCourseID);
			dispatch(setCourseID(newCourseID));
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			console.log('CHECK', allCourses[newCourseID]);
			if (allCourses[newCourseID] === undefined) {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				await dispatch(fetchCourseData());
			} else {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				await dispatch(updateCourse(newCourseID));
			}
		}
	};

	return (
		<select
			className={'courseDropDown'}
			value={courseID}
			name="Course"
			onChange={async (event) => handleCourseChange(event.target.value)}
		>
			{courseList.map((el: any, index: number) => (
				<option
					key={el.id}
					value={el.id}
				>
					{el.title}
				</option>
			))}
		</select>
	);
};

export default CourseDropDown;
